import { parse, format } from 'date-fns'

export const formatDate = (date?: string) => {
    if (!date) return null
    try {
        const parsed = parse(date, 'dd/MM/yyyy', new Date())
        return format(parsed, 'yyyy-MM-dd')
    } catch {
        return null
    }
}


export const readAsBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = typeof reader.result === "string" ? reader.result : "";
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });